import styled from 'styled-components';
import { darken } from 'polished';

export const Reordenar = styled.button`
  background: #dbe1e9;
  border: 0;
  border-radius: 5px;
  color: #fff;
  width: 100%;
  padding: 5px 10px;

  background: #ff6d3c;

  &:hover {
    background: ${darken(0.1, '#ff6d3c')};
  }
`;
